export default __webpack_public_path__ + "static/media/dejan_l.8ebc3a92.jpg";